import { css } from "@emotion/react";
import MoonLoader from "react-spinners/MoonLoader";

const override = css`
  display: block;
  margin: 0 auto;
  color: yellow;
`;

function Loader() {
  return (
    <div className="centerDiv">
        <MoonLoader loading={true} css={override} size={150} />
    </div>
  );
}

export default Loader;
